<template>
  <v-container fluid grid-list-md style="padding: 30px">
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="eventoId"
          :items="eventos"
          item-text="nome"
          item-value="id"
          label="Selecione o Evento"
          @input="carregaVagas"
          color="#0D47A1"
        ></v-select>
      </v-col>
    </v-row>

    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />

    <div v-show="true">
      <Inscricoes ref="inscricoes"></Inscricoes>
    </div>

    <v-container>
      <h1>Gerar Mapa do Evento</h1>
      <v-form @submit.prevent="validacaoCamposMapa">
        <v-row>
          <v-col cols="12" sm="2">
            <v-text-field
              v-model.number="rows"
              label="Linhas"
              type="number"
              min="1"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              v-model.number="cols"
              label="Colunas"
              type="number"
              min="1"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              v-model="backgroundUrl"
              label="URL da Imagem de Fundo"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-combobox
              label="Tipo"
              :items="['Mesa', 'Cadeira']"
              outlined
              v-model="tipoLugar"
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select
              label="Setor"
              :items="setoresEvento"
              item-text="nome"
              item-value="nome"
              outlined
              v-model="setor"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn dark color="#0056b3" x-large type="submit">Gerar Mapa</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <div
        ref="matrixContainer"
        :style="backgroundStyle"
        style="overflow: hidden; display: inline-block"
      >
        <table ref="matrixTable">
          <tr v-for="(row, rowIndex) in matrix" :key="rowIndex">
            <td
              v-for="(cell, colIndex) in row"
              :key="colIndex"
              @click="cellClicked(rowIndex, colIndex)"
              :class="{ active: cell.active }"
              :data-cell-number="cell.localizacao"
            >
              {{ cell.vaga }}
            </td>
          </tr>
        </table>
      </div>
      <div>
        <span v-if="clickedCells != ''">
          <v-btn dark color="#4a148c" x-large @click="saveMap()">Salvar Mapa</v-btn>
        </span>
      </div>
    </v-container>
  </v-container>
</template>

<script>
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  import { baseApiUrl } from "@/global";
  import Snackbar from "../componentes/snackbar.vue";
  import Inscricoes from "../componentes/inscricoes.vue";
  // import moment from "moment";
  import axios from "axios";
  // import PH from "print-html-element";
  import { mapState } from "vuex";
  export default {
    components: {
      Snackbar,
      Loading,
      Inscricoes,
    },

    data: () => ({
      eventoId: "",
      tipoLugar: "",
      eventos: [],
      eventoIdAtual: "",
      dadosEvento: "",
      setor: "",
      setoresEvento: [],
      fullPage: true,
      isLoading: false,
      loading: false,
      search: "",
      rows: 0,
      cols: 0,
      backgroundUrl: "",
      matrix: [],
      clickedCells: [],
    }),

    computed: mapState({
      usuarioLogado: (state) => state.isMenuVisible,
      user: (state) => state.userObj,
      companyobj: (state) => state.companyObj,
      backgroundStyle() {
        return {
          backgroundImage: `url('${this.backgroundUrl}')`,
          backgroundSize: "contain",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
        };
      },

      formTitle() {
        return this.editedIndex === -1
          ? "ADICIONAR INSCRIÇÃO"
          : "EDITAR INSCRIÇÃO";
      },
    }),

    mounted() {
      this.carregaDados();
    },

    methods: {
      async carregaDados() {
        this.isLoading = true;
        await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"${this.companyobj.id}"}]}}&access_token=${sessionStorage.getItem("accToken")}`)
        .then((res) => {
          if (res.data != "") {
            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                this.eventos.push(res.data[key]);
              }
            }
            this.eventos = this.eventos.sort(this.compare);
            this.eventoId = this.eventos[0].id;
            this.rows = this.eventos[0].matrizLinha;
            this.cols = this.eventos[0].matrizColuna;
            this.backgroundUrl = this.eventos[0].urlMapa;
            this.setoresEvento = this.eventos[0].setores
            if (this.rows && this.cols && this.backgroundUrl) {
              this.generateMatrix();
              this.getVagas();
              // console.log(this.clickedCells);
            }
            this.isLoading = false;
            if (this.eventoIdAtual != "") this.eventoId = this.eventoIdAtual;
          } else this.isLoading = false;
        });

        this.quantidade = [];
        for (let i = 0; i < 51; i++) {
          if (i > 0) {
            this.quantidade.push(i);
          }
        }
      },

      async carregaVagas() {
        let eventoSelecionado = this.eventos.filter(evento => evento.id === this.eventoId)
        
        this.rows = eventoSelecionado[0].matrizLinha;
        this.cols = eventoSelecionado[0].matrizColuna;
        this.backgroundUrl = eventoSelecionado[0].urlMapa;
        this.setoresEvento = eventoSelecionado[0].setores;

        if (this.rows && this.cols && this.backgroundUrl) {
          this.generateMatrix();
          this.getVagas();
        }
      },

      async getVagas() {
        this.isLoading = true;
        try {
          const response = await axios.get(`${baseApiUrl}Vagas?filter={"where":{"eventoId":"${this.eventoId}"}}&access_token=${sessionStorage.getItem("accToken")}`);

          // Normaliza os dados de `localizacao` para números
          this.clickedCells = response.data.map((vaga) => ({
            ...vaga,
            localizacao: parseInt(vaga.localizacao),
          }));

          // console.log("Dados das vagas carregados e normalizados:", this.clickedCells);
          this.updateMatrixCells();
          this.isLoading = false;
        } catch (error) {
          // console.error("Erro ao carregar vagas:", error);
          this.isLoading = false;
        }
      },

      updateMatrixCells() {
        let updatedMatrix = this.matrix.map(
          (row) => row.map((cell) => {
            // Converte `cell.localizacao` para número, se ainda não for, e compara com a `localizacao` de `clickedCells` convertida para número
            const found = this.clickedCells.find(
              (c) => parseInt(c.localizacao) === cell.localizacao
            );

            if (found) {
              // Se encontrada, atualiza a célula com os dados da vaga encontrada e marca como ativa
              return { ...cell, ...found, active: true };
            }
          
            return cell; // Retorna a célula como está se não encontrar correspondência
          })
        );

        this.matrix = updatedMatrix; // Substitui a matriz antiga pela nova para forçar a reatividade
        // console.log("Matriz atualizada com vagas marcadas:", this.matrix);
      },

      // FUNCOES MAPA
      generateMatrix() {
        this.matrix = [];
        for (let i = 0; i < this.rows; i++) {
          const row = [];
          for (let j = 0; j < this.cols; j++) {
            const localizacao = i * this.cols + j + 1;
            row.push({
              localizacao,
              active: false,
              status: "LIVRE",
              tipo: "",
              vaga: "",
              empresaId: this.companyobj.id,
              eventoId: this.eventoId,
              setor: this.setor,
            });
          }
          this.matrix.push(row);
        }

        // Espera a matriz ser criada e então carrega as vagas e atualiza a matriz
        this.$nextTick(() => {
          this.adjustBackgroundSize();
          this.getVagas().then(() => {
            this.updateMatrixCells(); // Atualiza a matriz com os dados recém carregados
          });
        });
      },

      cellClicked(rowIndex, colIndex) {
        if (this.rows && this.cols && this.backgroundUrl && this.tipoLugar && this.setor) {
          const cell = this.matrix[rowIndex][colIndex];
  
          if (!cell.active) {
            cell.active = true;
            cell.tipo = this.tipoLugar;
            cell.vaga = this.clickedCells.length + 1;
            this.clickedCells.push({ ...cell });
          } else {
            cell.active = false;
            cell.vaga = "";
            const index = this.clickedCells.findIndex(
              (c) => c.localizacao === cell.localizacao
            );
            if (index !== -1) {
              this.clickedCells.splice(index, 1);
            }
          }
  
          this.$set(this.matrix, rowIndex, [...this.matrix[rowIndex]]);
          // console.log(`Célula em rowIndex: ${rowIndex}, colIndex: ${colIndex} atualizada`, cell);
        }
      },

      updateClickedCells() {
        this.clickedCells.forEach((cell, index) => {
          const matrixCell = this.matrix
            .flat()
            .find((c) => c.localizacao === cell.localizacao);
          if (matrixCell) {
            matrixCell.vaga = index + 1;
          }
        });
      },

      adjustBackgroundSize() {
        const matrix = this.$refs.matrixTable;
        const container = this.$refs.matrixContainer;
        if (matrix && container) {
          // Ajusta o tamanho da imagem para cobrir as dimensões da tabela
          this.backgroundStyle.backgroundSize = `${matrix.offsetWidth}px ${matrix.offsetHeight}px`;

          // Certifique-se que a posição de fundo é centralizada
          this.backgroundStyle.backgroundPosition = "center center";

          // Aplica os estilos ao container diretamente para garantir que sejam aplicados
          container.style.backgroundImage = this.backgroundStyle.backgroundImage;
          container.style.backgroundSize = this.backgroundStyle.backgroundSize;
          container.style.backgroundPosition = this.backgroundStyle.backgroundPosition;
          container.style.backgroundRepeat = "no-repeat";
          container.style.width = `${matrix.offsetWidth}px`;
          container.style.height = `${matrix.offsetHeight}px`;
        }
      },

      async updateEvento() {
        let dados = {
          matrizLinha: this.rows,
          matrizColuna: this.cols,
          urlMapa: this.backgroundUrl,
        }

        await axios.patch(`${baseApiUrl}Eventos/${this.eventoId}?access_token=${sessionStorage.getItem("accToken")}`, dados);
      },

      async saveMap() {
        var vm = this;

        this.isLoading = true;
        await axios.post(`${baseApiUrl}Vagas?access_token=${sessionStorage.getItem("accToken")}`, this.clickedCells)
        .then((res) => {
          if (res.data != null) {
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO");
            this.updateEvento();
            this.carregaDados();
          }
        })
        .catch(() => {
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO");
        });
      },

      validacaoCamposMapa() {
        let vm = this

        if (this.rows && this.cols && this.backgroundUrl && this.tipoLugar && this.setor) {
          this.generateMatrix()
        } else {
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
        }
      },
    },
  };
</script>

<style scoped>
  .textoUser {
    font-weight: bold;
    color: #00253e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url("https://fonts.google.com/specimen/Roboto");
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }

  table {
    border-collapse: collapse;
  }

  td {
    width: 30px;
    height: 30px;
    border: 1px solid black;
  }

  .active {
    background-color: #4caf50;
    color: white;
  }

  form {
    text-align: center;
    margin-bottom: 20px;
  }

  input[type="number"],
  input[type="text"] {
    padding: 8px;
    margin-right: 10px;
    margin-top: 10px;
  }

  button {
    padding: 10px 20px;
    cursor: pointer;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
  }

  button:hover {
    background-color: #0056b3;
  }

  #clickedCellsInfo {
    text-align: center;
    margin-top: 10px;
  }
</style>
